import React from "react";

const SectionHeader = ({ title, headerLeft, headerRight, isPageScrolled = false }) => {
	return (
		<div className={"analytics-section-header" + (isPageScrolled ? " scrolled" : "")}>
			<div className="section-header-left">{title || headerLeft}</div>
			<div className="section-header-right">{headerRight}</div>
		</div>
	);
};
export default SectionHeader;
